import { render, staticRenderFns } from "./gaojing.vue?vue&type=template&id=41b9935d&scoped=true"
import script from "./gaojing.vue?vue&type=script&lang=js"
export * from "./gaojing.vue?vue&type=script&lang=js"
import style0 from "./gaojing.vue?vue&type=style&index=0&id=41b9935d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b9935d",
  null
  
)

export default component.exports